import axios from 'axios'
import {host} from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'


const dataInicial = {

    asociados: [
      
    ],
    
    asociadosDummy: [
        {
            id: 1, numeroSocio: '001', personaFisica: true, personaMoral: false, nombreRazonSocial: 'MEZCAL ORO DE OAXACA', fechaSolicitud: 'DATOS DUMMY 1',
            rfc: 'DATOS DUMMY 1', telefono: 'DATOS DUMMY 1', correoElectronico: 'DATOS DUMMY 1', nombreRepresentanteLegal: 'nombreRepresentanteLegal',
            telefonoRepresentante: 'DATOS DUMMY 1', correoElectronicoRepresentante: 'DATOS DUMMY 1', empresaCertificadora: 'DATOS DUMMY 1', TipoCliente: 1, idLogin: 1,
            instalaciones: [
                {
                    id: 1, nombre: 'Fabrica', direccion: 'Dirección 1-1', tipo: '', inspector: '', isValidado: false,
                    solicitudes: [
                        { id: 'solicitud1', tipo: 1, nombreSolicitud: 'Solicitud 1', dia: 13, mes: 1, anio: 2022, fechaPropuesta: '16/04/2022', estado: 1, prioridad: 0, inspector: 'José Alfredo Cruz Velásco' },
                        { id: 'solicitud2', tipo: 2, nombreSolicitud: 'Solicitud 2', dia: 1, mes: 2, anio: 2022, fechaPropuesta: '16/04/2022', estado: 2, prioridad: 0, inspector: 'José Alfredo Cruz Velásco' },
                        { id: 'solicitud3', tipo: 3, nombreSolicitud: 'Solicitud 3', dia: 16, mes: 3, anio: 2022, fechaPropuesta: '17/04/2022', estado: 3, prioridad: 2, inspector: 'José Alfredo Cruz Velásco' },
                    ]
                },
                { id: 2, nombre: 'Envasadora', direccion: 'Dirección 1-2', tipo: '', inspector: '', isValidado: false, solicitudes: [] },
                { id: 3, nombre: 'Destiladora', direccion: 'Dirección 1-3', tipo: '', inspector: '', isValidado: false, solicitudes: [] },
                { id: 4, nombre: 'Bodega', direccion: 'Dirección 1-4', tipo: '', inspector: '', isValidado: false, solicitudes: [] },
                { id: 5, nombre: 'Sucursal 1', direccion: 'Dirección 1-5', tipo: '', inspector: '', isValidado: false, solicitudes: [] },
                { id: 5, nombre: 'Sucursal 2', direccion: 'Dirección 1-6', tipo: '', inspector: '', isValidado: false, solicitudes: [] }
            ],
            nivelDeSolicitudes: 1, totalSolicitudes: 0
        },
        {
            id: 2, numeroSocio: '002', personaFisica: true, personaMoral: false, nombreRazonSocial: 'MEZCAL TOBALÁ DE MÉXICO', fechaSolicitud: 'DATOS DUMMY 2',
            rfc: 'DATOS DUMMY 2', telefono: 'DATOS DUMMY 2', correoElectronico: 'DATOS DUMMY 2', nombreRepresentanteLegal: 'DATOS DUMMY 2',
            telefonoRepresentante: 'DATOS DUMMY 2', correoElectronicoRepresentante: 'DATOS DUMMY 2', empresaCertificadora: 'DATOS DUMMY 2', TipoCliente: 2, idLogin: 2,
            instalaciones: [
                { id: 11, nombre: 'Fabrica', direccion: 'Dirección 2-1', tipo: '', inspector: '', isValidado: false, solicitudes: [] },
                { id: 22, nombre: 'Envasadora', direccion: 'Dirección 2-2', tipo: '', inspector: '', isValidado: false, solicitudes: [] },
                { id: 33, nombre: 'Destiladora', direccion: 'Dirección 2-3', tipo: '', inspector: '', isValidado: false, solicitudes: [] },
                { id: 44, nombre: 'Bodega', direccion: 'Dirección 2-4', tipo: '', inspector: '', isValidado: false, solicitudes: [] },
                { id: 55, nombre: 'Sucursal 1', direccion: 'Dirección 2-5', tipo: '', inspector: '', isValidado: false, solicitudes: [] },
                { id: 66, nombre: 'Sucursal 2', direccion: 'Dirección 2-6', tipo: '', inspector: '', isValidado: false, solicitudes: [] }
            ],
            nivelDeSolicitudes: 1, totalSolicitudes: 0
        }


    ],
    instalaciones:[]
}


//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ASOCIADOS = 'GET_ASOCIADOS'
const GET_ASOCIADO_BY_ID = 'GET_ASOCIADO_BY_ID'
const GET_ASOCIADO_BY_NOMBRE= 'GET_ASOCIADO_BY_NOMBRE'
const INSERT_ASOCIADO = 'INSERT_ASOCIADO'
const UPDATE_ASOCIADO = 'UPDATE_ASOCIADO'
const  GET_INSTALACIONES_BY_CLIENTE = 'GET_INSTALACIONES_BY_CLIENTE';
//*******************************************************************************************************************



//MÉTODOS 
export const getAsociados = createAsyncThunk(
    GET_ASOCIADOS,
    async () => {
        try {
            const fullUrl = host + `DatosAsociado/getAsociados`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getAsociadoById = createAsyncThunk(
    GET_ASOCIADO_BY_ID,
    async (idAsociado) => {
        try {
            const fullUrl = host + `DatosAsociado/getAsociadoById/${idAsociado}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getAsociadoByNombre = createAsyncThunk(
    GET_ASOCIADO_BY_NOMBRE,
    async (nombre) => {
        try {
            const fullUrl = host + `DatosAsociado/getAsociadoByNombre/${nombre}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertAsociado = createAsyncThunk(
    INSERT_ASOCIADO,
    async (data) => {
        try {
            const fullUrl = host + `DatosAsociado/insertAsociado`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateInspector = createAsyncThunk(
    UPDATE_ASOCIADO,
    async (data) => {
        try {
            const fullUrl = host + `DatosAsociado/updateAsociado`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const validarInstalacion = createAsyncThunk(
)

export const getInstalacionesByCliente = createAsyncThunk(
    GET_INSTALACIONES_BY_CLIENTE,
    async (idcliente) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerInstalacionesRelacionadas/${idcliente}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
//****************************************************************************************************************



//EXPORTS DE MÉTODOS
export const metodosAsociadoSlice = createSlice({
    name: 'metodosAsociadosSlice',
    initialState: dataInicial,
    reducers: {
       
    },
    extraReducers: {
      
        [getAsociados.fulfilled]: (state, { payload }) => {
            state.data = payload.data.data
        },
        [getInstalacionesByCliente.fulfilled]: (state, { payload }) => {
           state.instalaciones = payload.data.data
        },
        [getAsociadoById.fulfilled]: (state, { payload }) => {
         
        },

        [getAsociadoByNombre.fulfilled]: (state, { payload }) => {
       
        },

        [insertAsociado.fulfilled]: (state, { payload }) => {
            state.data = payload.data
        },

        [updateInspector.fulfilled]: (state, { payload }) => {
            state.data = payload.data
        },

        [validarInstalacion.fulfilled]: (state, { payload }) => {
           
        },
    },
})


/*export const AsociadoSlice = createSlice({
    initialState: dataInicial,
    name: 'AsociadoSlice',
    reducers: {
        agregarAsociado(state, { payload }) {
            state.asociados.push(payload)
        },


        editarAsociado(state, { payload }) {
            console.log(payload)
            state.asociados.map((asociado) => {
                if (asociado.id === payload.id) {

                }
            })
        },

        eliminarAsociado(state, { payload }) {
            const filteredAsociados = state.asociados.filter(asociado => asociado.id !== payload)
            state.asociados = filteredAsociados
        },

        validarInstalacion(state, { payload }) {

            state.asociados.map((asociado) => {
                if (asociado.id === parseInt(payload[0])) {
                    asociado.instalaciones.map((instalacion) => {
                        if (instalacion.id === parseInt(payload[1])) {
                            instalacion.isValidado = true
                        }
                    })
                }
            })

        }



        /*LOCALIDADES
        agregarAsociadocalidad(state, { payload }) {
            state.zonas.map((zona) => {
                if (zona.id === payload.zona) {
                  
                    zona.localidades.push(payload)
                    
                }
            })
  
        },

        editarLocalidad(state, { payload }) {
            state.zonas.map((zona) => {
                if (zona.id === parseInt(payload.zona)) {
                    zona.localidades.map((localidad) => {
                        if (localidad.id === parseInt(payload.id)) {
                            localidad.id == payload.id
                            localidad.nombre = payload.nombre,
                            localidad.lat = payload.lat,
                            localidad.Ing = payload.Ing,
                            localidad.pin = payload.pin,
                            localidad.asociados = payload.asociados
                        }
                    })
                }
            })
        },

        eliminarLocalidad(state, { payload }) {
           
            state.zonas.map((zona) => {
                if (zona.id === parseInt(payload[0].zona)) {
                    zona.localidades.map((localidad) => {
                        if (localidad.id === parseInt(payload[0].localidad)) {                          
                            const localidadesNuevas = zona.localidades.filter(l => l.id !== parseInt(payload[0].localidad))
                            zona.localidades = localidadesNuevas
                        }
                    })
                }
            })
        },

        activarAsociado(state, { payload }) {

        console.log(payload)
            state.zonas.map((zona) => {
                if (zona.id === parseInt(payload[0].zona)) {
                    zona.localidades.map((localidad) => {
                        if (localidad.id === parseInt(payload[0].localidad)) {    
                            localidad.asociados.map((asociado) => {
                                if (asociado.id === parseInt(payload[0].asociado)) { 
                                        asociado.estado=1                      
                                }   
                            })                      
                            
                        }
                    })
                }
            })
        },

        //Control de inspectores

        sustituirInspector(state, {payload}) {
            console.log(payload)
            state.zonas.map(zona => {
                if(zona.id == payload.zona.id){
                    zona.inspector = payload.inspector.id
                }
            })
        }
        
    }
})
*/




/*export const {
    agregarAsociado,
    editarAsociado,
    eliminarAsociado,
    validarInstalacion

} = AsociadoSlice.actions

*/
 export const { } = metodosAsociadoSlice.actions

export const AsociadoReducer = metodosAsociadoSlice.reducer
